export default __webpack_public_path__ + "static/media/1.cb425a21.png";